module.exports = __webpack_public_path__ + "static/gallery-3@2x-30a88106371fdb0081cb491332570d45.jpg";